import { createRouter, createWebHistory } from "vue-router";

import Welcome from "./components/Welcome.vue";
import Details from "./components/service/Details.vue";
import Ages from "./components/service/Ages.vue";
import Location from "./components/service/Location.vue";
import Availability from "./components/service/Availability.vue";
import ServicePricing from "./components/service/ServicePricing.vue";
import AddVenue from "./components/AddVenue.vue";
import SimpleEventVenues from "./components/SimpleEventVenues.vue";
import AddEventToVenue from "./components/AddEventToVenue.vue";
import ListingFunnelNew from "./components/ListingFunnelNew.vue";
import AddCourseDetails from "./components/advanced-flow/AddCourseDetails.vue";
import AddHoliday from "./components/advanced-flow/AddHoliday.vue";
import AddVenuetoCourse from "./components/advanced-flow/AddVenuetoCourse.vue";

const path = "/register/create";

// Leaving this here as an example of lazy loading components
// const Welcome = () => import('./components/Welcome')

const routes = [
    {
        path,
        name: "Welcome",
        component: Welcome,
    },
    {
        path: `${path}/recovery/:id`,
        name: "Welcome recovery",
        component: Welcome,
        props: true,
    },
    {
        path: `${path}/listing-type`,
        name: "Listing type",
        component: ListingFunnelNew,
    },
    // new simple event flow
    {
        path: `${path}/add-venue`,
        name: "Add venue",
        component: AddVenue,
    },
    {
        path: `${path}/simple-event-venues`,
        name: "Simple venues",
        component: SimpleEventVenues,
    },
    {
        path: `${path}/:venueIdx/add-event`,
        name: "Add event to venue",
        component: AddEventToVenue,
    },
    {
        path: `${path}/:venueIdx/add-dates`,
        name: "Add dates",
        component: AddEventToVenue,
    },
    {
        path: `${path}/:venueIdx/tickets-and-price`,
        name: "Tickets and price",
        component: AddEventToVenue,
    },
    {
        path: `${path}/:venueIdx/add-pricing`,
        name: "Add pricing",
        component: AddEventToVenue,
    },
    {
        path: `${path}/:venueIdx/booking-settings`,
        name: "Booking settings",
        component: AddEventToVenue,
    },
    {
        path: `${path}/:venueIdx/add-holidays`,
        name: "Add holidays",
        component: AddEventToVenue,
    },
    {
        path: `${path}/:venueIdx/summary`,
        name: "Simple event summary",
        component: AddEventToVenue,
    },
    // Service
    {
        path: `${path}/service`,
        name: "Service",
        component: Details,
    },
    {
        path: `${path}/service/ages`,
        name: "Service ages",
        component: Ages,
    },
    {
        path: `${path}/service/location`,
        name: "Service location",
        component: Location,
    },
    {
        path: `${path}/service/availability`,
        name: "Service availability",
        component: Availability,
    },
    {
        path: `${path}/service/pricing`,
        name: "Service pricing",
        // component: PricingService,
        component: ServicePricing,
    },
    {
        path: `${path}/advanced-flow`,
        name: "New Listing Funnel",
        component: ListingFunnelNew,
    },
    {
        path: `${path}/advanced/add-course-details`,
        name: "Advanced Add Course",
        component: AddCourseDetails,
    },
    {
        path: `${path}/advanced/add-holidays`,
        name: "Advanced Add Holiday",
        component: AddHoliday,
    },
    {
        path: `${path}/advanced/add-venue`,
        name: "Advanced Add Venue",
        component: AddVenuetoCourse,
    },

];

const router = createRouter({
    history: createWebHistory(),
    routes,
    strict: true,
});

export default router;
